import { useMutation } from '@tanstack/react-query';

import { Entity } from '../../../../../types/utility';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { postApplicationGreenIdCheck } from '../../requests/postApplicationGreenIdCheck';

export const useApplicationGreenIdCheck = (definitionName: string) => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: performGreenIdCheck, ...rest } = useMutation({
    mutationFn: ({ uuid, data }: { uuid: string; data: Entity }) =>
      postApplicationGreenIdCheck(constructPost, uuid, definitionName, data),
  });

  return { performGreenIdCheck, ...rest };
};
